
import {useState,React} from 'react';
import { motion } from 'framer-motion';
import './homepage.css';
import '../App.css';
import BottomBar from './BottomBar';
import './WorkExperience.css';
import CircularMenu from './CircularMenu';
import VideoModal from './VideoModal';

const handleDownload = () => {
  const link = document.createElement('a');
  link.href = './resume.docx';
  link.download = 'resume.docx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const WorkExperience = () => {
  const experiences = [
    {
      company: 'CodSoft',
      role: 'Intern',
      description: 'During my Machine Learning internship, I gained hands-on experience in applying various machine learning models to solve real-life problems. This opportunity allowed me to deepen my understanding of different algorithms and their practical applications, enhancing my ability to develop and implement effective data-driven solutions.',
      duration: '9/23 – 10/23',
    },
    {
      company: 'Data Science Association',
      role: 'Joint Secretary',
      description: ' I played a key role in organizing events, coordinating activities, and fostering collaboration among members to achieve the clubs objectives.',
      duration: '2023 (Present)',
    },
    {
      company: 'O (1) Coding Club',
      role: 'Intern - Content Team',
      description: 'I handled the social media profiles, creating and managing content to enhance the companies online presence and community engagement.',
      duration: '11/22 – 06/23',
    },
    {
      company: 'Codechef RCOEM Chapter ',
      role: 'Problem Setter',
      description: '',
      duration: '03/22 – 09/22',
    },
    // Add more experiences as needed
  ];

  const variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };
  const [showModal, setShowModal] = useState(false);

const handleOpenModal = () => {
  setShowModal(true);
}

const handleCloseModal = () => {
  setShowModal(false);
}
  return (
    <div className="homepagedark">
      <div className="bg1">
        <div className="bg-item"></div>
        {/* <div className="line-group">
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
          <div className="frame-child5"></div>
        </div> */}
      </div>
      <div className="ololade-group">
        <div className="ololade2">
          <span>WORK EXPERIENCE</span>
          <span className="span2">.</span>
        </div>
        {/* <button className="download-btndark" onClick={handleDownload}>
          <div className="download-btndark-child"></div>
          <div className="download-btndark-item"></div>
          <div className="resume1">Resume</div>
          <img
            className="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button> */}
      </div>
      <div class="ololade-group">
        <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 680,
  }}>
    <button class="download-btndark" onClick={handleOpenModal}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Visume</div>
          <VideoModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        videoSrc="" 
      />
          {/* <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          /> */}
        </button>
  </div>
  <div style={{
    position: 'absolute',
    top: 5,
    left: 830,
  }}>
    <button class="download-btndark" onClick={handleDownload}>
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </button>
  </div>
</div>
        
        
      </div>
      <div className="experience-container">
        <h2 className="experience-heading">Work Experience</h2>
        {experiences.map((experience, index) => (
          <motion.div
            key={index}
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ duration: 0.6, delay: index * 0.3 }}
            className="experience-card1"
          >
            <h3>{experience.role}</h3>
            <h4>{experience.company}</h4>
            <p>{experience.description}</p>
            <p>{experience.duration}</p>
          </motion.div>
        ))}
      </div>
      <BottomBar />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
  <div style={{
    position: 'absolute',
    bottom: 97,
    right: 50,
  }}>
    <CircularMenu />
  </div>
</div>
    </div>
    
  );
};

export default WorkExperience;
